import API from '@/api';
const Medicine = API.get('Medicine');

export default ({
  namespaced: true,
  state: {
    last_page: 0,
    medicines: [],
    medicine: null,
    fave_medicines: JSON.parse(localStorage.getItem('favorite_medicines') || '{}'),
    used_medicines: JSON.parse(localStorage.getItem('most_used_medicines') || '{}')
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */
  
  getters: {
    last_page: state => state.last_page,
    medicines: state => state.medicines,
    medicine: state => state.medicine,
    fave_medicines: state => state.fave_medicines,
    used_medicines: state => state.used_medicines
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {

    setLastPage(state, last_page) {
      state.last_page = last_page
    },

    /* ################################################## METHOD SEPARATORS ################################################## */
    
    setMedicines(state, medicines) {
      state.medicines = medicines
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setMedicine(state, medicine) {
      state.medicine = medicine
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setFavoriteMedicines(state) {
      state.fave_medicines = JSON.parse(localStorage.getItem('favorite_medicines'))
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    addToMostUsed(state, medicine) {
      var medicines = state.medicines // all medicines
      var used_medicines = JSON.parse(localStorage.getItem('most_used_medicines')) // mosed used medicines from localStorage

      // if used_medicnes has data
      if (used_medicines && used_medicines.length > 0) {
        let index = used_medicines.findIndex(item=>item.id==medicine.id)

        // if medicine is already recorded
        if (index >= 0) {
          used_medicines[index].uses++
          Medicine.updateMostUsed({medicine_id: used_medicines[index].id, uses: used_medicines[index].uses});
          let sorted_medicines = used_medicines.sort((a,b) => a.uses - b.uses)
          localStorage.setItem('most_used_medicines', JSON.stringify(sorted_medicines))
          state.used_medicines = sorted_medicines
        }

        // if medicine is not yet recorded
        else {
          // find medicine in original list
          let index = medicines.findIndex(item=>item.id==medicine.id)

          // if medicine exists
          if (index >= 0) {
            medicines[index].uses = 1
            Medicine.updateMostUsed({medicine_id: medicines[index].id, uses: medicines[index].uses});
            var new_medicine = medicines[index]
            used_medicines.push(new_medicine)
            localStorage.setItem('most_used_medicines', JSON.stringify(used_medicines))
            state.used_medicines = used_medicines
          }
        }
      }

      // if used_medicines is empty
      else {
        // find medicine in original list
        let index = medicines.findIndex(item=>item.id==medicine.id)

        // if medicine exists
        if (index >= 0) {
          let new_used_medicines = [] // create new array
          medicines[index].uses = 1 // add initial number of uses
          Medicine.updateMostUsed({medicine_id: medicines[index].id, uses: medicines[index].uses});
          new_used_medicines.push(medicines[index]) // add medicine to array
          localStorage.setItem('most_used_medicines', JSON.stringify(new_used_medicines))
          state.used_medicines = new_used_medicines
        }
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    addToFavorites(state, medicine) {
      var medicines = JSON.parse(localStorage.getItem('favorite_medicines'))
      medicines.push(medicine)
      localStorage.setItem('favorite_medicines', JSON.stringify(medicines))
      state.fave_medicines = medicines
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    removeFromFavorites(state, id) {
      var medicines = JSON.parse(localStorage.getItem('favorite_medicines'))
      var index = medicines.findIndex(item => item.id == id)
      medicines.splice(index, 1)
      localStorage.setItem('favorite_medicines', JSON.stringify(medicines))
      state.fave_medicines = medicines
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    createFavorites(state, medicine) {
      var new_fave_medicines = []
      new_fave_medicines.push(medicine)
      localStorage.setItem('favorite_medicines', JSON.stringify(new_fave_medicines))
      state.fave_medicines = new_fave_medicines
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async fetchMedicines(state, {per_page=null, page=null, search=null}) {
      var id = ''
      
      var response = null;

      console.log("[search]", search);

      if(search == null) {
        response = await Medicine.get(id, per_page, page);
        state.commit('setMedicines', response.data.data)
        state.commit('setLastPage', response.data.last_page)
      } else {
        response = await Medicine.get(id, per_page, page, search);
        state.commit('setMedicines', response.data.data)
        state.commit('setLastPage', response.data.last_page)
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async fetchMedicine(state, id) {
      var response = await Medicine.get(id);
      state.commit('setMedicine', response.data)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async search(state, search) {
      var response = await Medicine.search(search);
      state.commit('setMedicines', response.data.data)
      state.commit('setLastPage', response.data.last_page)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    updateFavorites({commit}, medicine) {
      var medicines =  JSON.parse(localStorage.getItem('favorite_medicines'))
      if (medicines && medicines.length > 0) {
        let index = medicines.findIndex(item => item.id == medicine.id)
        
        if (index < 0) {
          commit('addToFavorites', medicine)
          Medicine.updateFavorites({medicine: medicine, type: 'add'});
        } else {
          commit('removeFromFavorites', medicines[index].id)
          Medicine.updateFavorites({medicine: medicine, type: 'delete'});
        }
      } else {
        commit('createFavorites', medicine)
        Medicine.updateFavorites({medicine: medicine, type: 'add'});
      }
    },

    async getFavoritesMedicines (state) {
      let response = await Medicine.getFavorites()
      localStorage.setItem('favorite_medicines', JSON.stringify(response.data.data));
      state.commit('setFavoriteMedicines');
    }
  }
})